export default "__VITE_ASSET__gJvBZrn5__"